import { DataBean } from "../DataBean";

export class ClosePhysical extends DataBean {


    public async closePhysicalTaking(idPhysicalTaking:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_closePhysicalTaking_Number", [idPhysicalTaking]);
    }

}